(function() {
    'use strict';

    angular.module('swif.reservations')
        .controller('PlanningReservationModal', PlanningReservationModal)
        .controller('PlanningReservationActionModal', PlanningReservationActionModal)
        .controller('reservationActionRouter', reservationActionRouter)
        .controller('ReservationFormModalController', ReservationFormModalController);


    function PlanningReservationModal($scope, $location, $uibModalInstance, swif, openresa, modalParams) {
        'ngInject';
        openresa.rights.getUserAbility($scope);
        $scope.removeLine = removeLine;
        $scope.createRequest = createRequest;
        $scope.createBooking = createBooking;
        $scope.cancel = cancel;

        $scope.model = openresa.requests.init();
        $scope.currentBooking = openresa.bookings.init();
        // fill booking with data coming from calendar
        _.merge($scope.currentBooking, modalParams);
        $scope.currentBooking.partner_id = $scope.model.partner_id;
        $scope.model.bookings.push($scope.currentBooking);

        //il faut le patner_id dans currentBooking
        _.forEach($scope.currentBooking.resources, function(resource) {
            openresa.bookables.addResource($scope.currentBooking, [resource, '']);
        });
        delete $scope.currentBooking.resources;

        function removeLine(booking, line) {
            _.remove(booking.lines, function(elt) {
                return elt === line;
            });
        }

        function createRequest() {
            var model = $scope.model;
            var action = swif.action.getActionById('reservationRequest', 'list', 'add', model);
            if (action) {
                // $uibModalInstance.close($scope.model);
                var options = {
                    preModal: openresa.requests.preModal,
                    preValidate: openresa.requests.preValidate,
                    callback: function(err, data) {
                        $uibModalInstance.close($scope.model);
                        openresa.planning.getCollection().getItems();
                        return openresa.requests.callback(err, data);
                    }
                };
                swif.action.dispatch('reservationRequest', action, model, options);
            }
        }

        function createBooking() {
            var model = $scope.currentBooking;
            var action = swif.action.getActionById('reservation', 'list', 'add', model);
            if (action) {
                // $uibModalInstance.close($scope.model);
                var options = {
                    preModal: openresa.planning.preModal,
                    preValidate: openresa.planning.preValidate,
                    callback: function(data) {
                        $uibModalInstance.close($scope.model);
                        openresa.planning.getCollection().getItems();
                        return openresa.planning.callback(data);
                    }
                };
                swif.action.dispatch('reservation', action, model, options);
            }
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

    }

    function PlanningReservationActionModal($scope, $uibModalInstance, $q, openresa, swif, modalParams) {
        'ngInject';
        $scope.cancel = cancel;
        $scope.currentPage = 1;
        $scope.fetchedPages = [];
        $scope.secondPreModal = secondPreModal;
        $scope.secondPreValidate = secondPreValidate;
        $scope.secondCallback = secondCallback;
        $scope.redirectToRequest = redirectToRequest;
        $scope.initialize = initialize;
        $scope.loadOccurrences = loadOccurrences;

        initialize();

        function initialize() {
            $scope.loader = {};
            $scope.request = {};
            var user = swif.user.getAuthenticatedUserData();
            // All bookables resources are loaded here
            var managedBookables = user.managed_bookables || [];
            $scope.model = openresa.bookings.init(modalParams.data);

            //TG3652 - If the bookable resource is not manageable by user, he can't update it
            const filteredArray = $scope.model.resource_ids.filter(value => managedBookables.includes(value))
            if (filteredArray.length == 0) {
                $scope.model.manager_can_update = false;
            } else {
                $scope.model.manager_can_update = true;
            }
            openresa.bookings.fetch($scope.model);
        }

        function resourcesToLines(model) {
            model.lines = [];
            _.forEach(model.resources, function(resource) {
                var line = angular.copy(resource);
                line.resource = resource;
                line.product_id = [resource.id, resource.name];
                line._type = 'dummy';
                line.id = resource.booking_line_id;
                model.lines.push(line);
            });
            openresa.bookables._computeLineAvailability(model);
            return model;
        }

        function loadOccurrences() {
            // initialize the collection (fetch WHOLE data)
            // if already fetched, return the collection itself
            if ($scope.occurrences) {
                return $scope.occurrences;
            }
            // ensure the booking has a recurrence, and fetch it
            if ($scope.model.recurrence_id) {
                swif.message.loading($scope.loader);
                var filter = { fields: ['resources'] };
                var recurId = $scope.model.recurrence_id[0];
                swif.data.addFilter(filter, 'recurrence_id', '=', recurId);
                swif.data.sortOn(filter, 'checkin', 'ASC');
                openresa.bookings.initCollection(filter, { limitPerPage: 0 })
                    .then(function(coll) {
                        var occurrences = angular.copy(coll);
                        occurrences.items = _.map(occurrences.items, resourcesToLines);
                        $scope.occurrences = occurrences;
                        swif.message.loading($scope.loader, 'ok');
                    }, function() {
                        swif.message.loading($scope.loader, 'ko');
                    });
            }
            return $scope.occurrences;
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function secondPreModal(data) {
            var ret = openresa.planning.preModal(data);
            return ret;
        }

        // override the default preValidate method
        // to dispatch the correct action (or the preValidate) to apply:
        // - request action dispatch (for request wkf actions)
        // - router action dispatch (for intermediate modal choosing 'request' or 'booking')
        // - standard preValidate (for booking wkf actions)
        function secondPreValidate(data) {
            var ret = true;
            if (_.contains(['confirm_request', 'refuse_request'], data.action.id)) {
                var newData = angular.copy(data);
                if (newData.model.request_id) {
                    newData.model = openresa.requests.init(newData.model);
                    ret = swif.data.get(openresa.requests.content_type, newData.model.request_id[0])
                        .then(function(res) {
                            _.merge(newData.model, res);
                            var options = {
                                preModal: openresa.requests.preModal,
                                preValidate: openresa.requests.preValidate,
                                callback: callback
                            };
                            var action = swif.action.getActionById(
                                'reservationRequest',
                                'workflow',
                                newData.action.id.replace('_request', ''),
                                newData.model
                            );
                            swif.action.dispatch('reservationRequest', action, newData.model, options);
                            return true;
                        });
                }
            } else if (_.contains(openresa.planning.ROUTER_ACTIONS, data.action.id)) {
                openresa.planning.routerDefer = $q.defer();
                // dispatch the action to the correct modal
                // planning service will resolve the routerDefer itself
                // (when action will be done)
                openresa.planning.routerDispatch(data);
                ret = openresa.planning.routerDefer.promise;
            } else {
                ret = openresa.planning.preValidate(data);
            }
            return ret;
        }

        function secondCallback(data) {
            openresa.planning.getCollection().getItems();
            $uibModalInstance.close($scope.model);
        }

        // used in template, on the pre-validate option
        function redirectToRequest(data) {
            // fetch actions of reservationRequest
            var filter = { fields: [] };
            swif.data.get('reservationRequest', data.model.request_id[0], filter)
                .then(function(res) {
                    // then, attach specific booking ID (display manage_events to correct date)
                    var request = res;
                    res._specificObjId = data.model.id;
                    data.model = res;
                    // finally, retrieve the related action
                    var action = null;
                    if (data.action.id === 'show_request') {
                        // apply edit action, or if not applicable, readonly action
                        action = swif.action.getActionById('reservationRequest', 'primary', 'edit', data.model);
                        if (!action) {
                            action = swif.action.getActionById('reservationRequest', 'notWorkflow', 'readonly', data.model);
                        }
                    } else if (data.action.id === 'show_event_request') {
                        action = swif.action.getActionById('reservationRequest', 'notWorkflow', 'manage_events', data.model);
                    }

                    // if action found, perform the action with preModal, etc...
                    if (action) {
                        var options = {
                            preModal: openresa.requests.preModal,
                            preValidate: openresa.requests.preValidate,
                            callback: callback
                        };
                        swif.action.dispatch('reservationRequest', action, data.model, options);
                    }
                });
        }

        function callback(err, data) {
            openresa.planning.getCollection().getItems();
            $uibModalInstance.close($scope.model);
            return openresa.requests.callback(err, data);
        }
    }

    function reservationActionRouter($scope, swif) {
        'ngInject';
        $scope.model._router = {
            action: $scope.model.request_id ? 'request' : 'reservation',
            recurrenceAction: 'whole'
        };
        $scope.availableActions = { request: false };
        $scope.request = {};
        if ($scope.model.request_id) {
            // fetch 'actions' of the request model
            var filter = { fields: ['actions'] };
            swif.data.get('reservationRequest', $scope.model.request_id[0], filter)
                .then(function(data) {
                    // and compute _router.action ('request' or 'reservation')
                    _.merge($scope.request, data);
                    var routedActionId = $scope.action.id.replace('router_', '');
                    // getActionById returns action only if available, that's exactly what i want here
                    var action = swif.action.getActionById(
                        $scope.request._type,
                        'primary',
                        routedActionId,
                        $scope.request
                    );
                    $scope.availableActions.request = Boolean(action);
                    if (!Boolean(action)) {
                        $scope.model._router.action = 'reservation';
                    }
                });
        }
    }

    function ReservationFormModalController($scope, swif, openresa) {
        'ngInject';
        // NOT USED for now
        $scope.getRecurrence = function() {
            var booking = $scope.proxy.booking;
            var model = openresa.recurrences.init(booking);
            var occurrencesFrom = $scope.model._router.recurrenceAction;
            swif.data.get('recurrenteReservation', $scope.proxy.booking.recurrence_id[0])
                .then(function(data) {
                    var same = data.checkin === booking.checkin && data.checkout === booking.checkout;
                    if (occurrencesFrom === 'whole' || same) {
                        _.merge(model, data);
                        // srv._initializeExistingLines(model);
                    } else {
                        _.merge(model, data);
                        model._type = 'recurrenteReservation';
                        delete model.id;
                    }
                });
            return model;
        };

        // retrieve existing occurrences, according to the router modal options
        // (whole: retrieve all occurrences, fromNow: retrieve occurrences FROM current booking date)
        // NOT USED for now
        $scope.getOccurrences = function() {
            var ret = [];
            var occurrencesFrom = $scope.model._router.recurrenceAction;
            if (occurrencesFrom) {
                var filter = {};
                swif.data.addFilter(filter, 'recurrence_id', '=', $scope.proxy.booking.recurrence_id[0]);
                swif.data.addFilter(filter, 'is_template', '=', false);
                swif.data.sortOn(filter, 'checkin', 'ASC');
                if (occurrencesFrom === 'fromNow') {
                    swif.data.addFilter(filter, 'checkin', '>=', $scope.proxy.booking.checkin);
                }

                swif.data.get('reservation', undefined, filter).then(function(data) {
                    _.forEach(data, function(item) {
                        ret.push(item);
                    });
                });
            }
            return ret;
        };

        $scope.prepareRecurrenceParser = function() {
            $scope.recurrenceParser = {};
            $scope.recurrenceParser.updateDates = function() {

            };
        };

        $scope.initialize = function() {
            // when calling _saveBooking from service preValidate,
            // i don't want the sanitzeBookingData to remove the recurrence,
            // (it checks the presence of 'recurrence' attribute),
            // so i force the recurrence attribute to be present
            if ($scope.model.recurrence_id) {
                $scope.model.recurrence = { id: $scope.model.recurrence_id[0] };
            }
            if (!$scope.model.state) {
                $scope.model.state = 'waiting';
            }
            $scope.filters = { requests: {} };
            openresa.requests.addOnlyContractsFilter($scope.filters.requests);
            $scope.proxy = { booking: $scope.model }; // to keep reference through ngModel
            openresa.rights.getUserAbility($scope);
            $scope.model.is = $scope.is;
            // @TOREMOVE ? NOT USED for now
            if ($scope.model._router) {
                if ($scope.model._router.action === 'recurrence' && $scope.proxy.booking.recurrence_id) {
                    $scope.prepareRecurrenceParser();
                    $scope.proxy.recurrence = $scope.getRecurrence();
                    $scope.model.recurrence = $scope.proxy.recurrence;
                    // retrieved existing occurrences
                    $scope.proxy.occurrences = $scope.getOccurrences();
                    $scope.model.occurrences = $scope.proxy.occurrences;
                }
            }
        };

        $scope.initialize();

        $scope.$watch('proxy.booking.request_id', function(newV, oldV) {
            if (!angular.equals(newV, oldV)) {
                var newString = newV ? newV[1] : '';
                var oldString = oldV ? oldV[1] : '';
                var currentName = $scope.proxy.booking.name || '';
                // sync the string with the name (bubble the value of the clear of value to name)
                if (currentName === oldString) {
                    $scope.proxy.booking.name = newString;
                }
            }
        });
    }

})();